import api from '../../utils/api';
import {
    GET_ALL_FUNCTIONAL,
    GET_SPECIFIC_FUNCTIONAL,
    UPDATE_SPECIFIC_FUNCTIONAL,
    CREATE_NEW_FUNCTIONAL,
    REMOVE_FUNCTIONAL
} from './types';
import { NotificationManager } from 'react-notifications';

export const getAllData = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/functional', { params: filter }).then(res => {
            dispatch({ type: GET_ALL_FUNCTIONAL, payload: res.data.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const createData = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/functional', data).then(res => {
            dispatch({ type: CREATE_NEW_FUNCTIONAL, payload: res.data.data });
            NotificationManager.success(res.data.msg);
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const getData = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get(`/functional/${id}`).then(res => {
            dispatch({ type: GET_SPECIFIC_FUNCTIONAL, payload: res.data.data });
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const updateData = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/functional/${id}`, data).then(res => {
            dispatch({ type: UPDATE_SPECIFIC_FUNCTIONAL, payload: res.data.data });
            NotificationManager.success(res.data.msg);
            resolve(res.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const removeData = (ids) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.delete(`/functional`, { data: { ids: ids } }).then(res => {
            dispatch({ type: REMOVE_FUNCTIONAL, payload: ids });
            NotificationManager.success(res.data.msg);
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}